import { ShieldAlert } from "lucide-react";

export default function ConsentNotice({ checked, onChange, testid = "consent-check" }) {
  return (
    <label className="flex items-start gap-3 rounded-2xl bg-amber-500/10 border border-amber-500/25 p-3 text-sm cursor-pointer" data-testid={`${testid}-label`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} className="mt-1 w-4 h-4 accent-amber-500" />
      <span><span className="font-semibold text-amber-500 inline-flex items-center gap-1"><ShieldAlert className="w-4 h-4" /> Rappel légal</span><br />
        J'ai informé les participants que la conversation est enregistrée et ils ont donné leur accord.</span>
    </label>
  );
}
